export const GET_SERIE_ID = 'yoga-adm/serie/get-serie-id';
export const GET_LESSONS_FROM_SERIE = 'yoga-adm/serie/get-lessons-from-serie';
export const GET_CURRENT_LESSON = 'yoga-adm/serie/get-current-lesson';
